import { useEffect, useState } from "react";

const UsePagination = (campos, ITEMS_POR_PAGINA = 9) => {
    const [camposActuales, setCamposActuales] = useState([])
    const [items, setItems] = useState([])
    const [paginaActual, setPaginaActual] = useState(0)
    const [numeroPaginas, setNumeroPaginas] = useState(0)
    const [camposActualesNumero, setCamposActualesNumero] = useState(0)
    const [terminado, setTerminado] = useState(false)
    const [itemsScroll, setItemsScroll] = useState([])

    useEffect(() => {
        setCamposActuales(campos)
        setItems([...campos].splice(0, ITEMS_POR_PAGINA))
        setItemsScroll([...campos].splice(0, ITEMS_POR_PAGINA))
        setNumeroPaginas(Math.ceil(campos.length / ITEMS_POR_PAGINA))
        setCamposActualesNumero(camposActuales.length)
        setTerminado(false)
        setPaginaActual(0)
    }, [campos])

    const handleSiguiente = () => {
        const totalElementos = camposActuales.length;
        const paginaSiguiente = paginaActual + 1;
        const primerIndex = paginaSiguiente * ITEMS_POR_PAGINA;

        setTerminado(primerIndex >= totalElementos)
        if (primerIndex >= totalElementos) return;
        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        const itemsNuevos = [...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA)

        setItemsScroll([...itemsScroll, ...itemsNuevos])

        setPaginaActual(paginaSiguiente)

    }

    const handleRegresar = () => {
        const paginaAnterior = paginaActual - 1;

        if (paginaAnterior < 0) return;
        const primerIndex = paginaAnterior * ITEMS_POR_PAGINA;

        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        setPaginaActual(paginaAnterior)
    }

    return {
        handleRegresar,
        handleSiguiente,
        items,
        numeroPaginas,
        camposActualesNumero,
        terminado,
        itemsScroll,
        paginaActual
    }
}

export default UsePagination